import { render, staticRenderFns } from "./ArtistCreate.vue?vue&type=template&id=5425be74&"
import script from "./ArtistCreate.vue?vue&type=script&lang=js&"
export * from "./ArtistCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports